module.exports = __webpack_public_path__ + "static/multiselect1-a4b3d23f0388790e9262d4b68313c667.png";